import { useEffect, useState } from "react";
import { Upload, Trash2, Copy } from "lucide-react";
import api, { mediaUrl, apiErr } from "@/lib/api";
import { toast } from "sonner";

export default function AdminMedia() {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);

  const load = () => api.get("/admin/media").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData(); fd.append("file", file);
    try { await api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Uploaded."); load(); }
    catch { toast.error("Upload failed."); }
    setUploading(false);
  };
  const del = async (it) => { if (!window.confirm("Delete this file?")) return; await api.delete(`/admin/media/${it.id}`); load(); };
  const copy = (it) => { navigator.clipboard.writeText(mediaUrl(it.url)); toast.success("URL copied."); };

  return (
    <div data-testid="admin-media">
      <div className="flex justify-between items-center mb-8">
        <div><h1 className="font-heading text-4xl tracking-tight">Media Library</h1><p className="font-body text-sm text-ink/60 mt-1">Upload imagery & video. Recommended: at least 1200px on the long edge · JPG/PNG/WebP or MP4 up to 8MB. Natural dimensions shown per file.</p></div>
        <label className="adm-btn"><Upload size={14} /> {uploading ? "Uploading…" : "Upload"}<input type="file" accept="image/*,video/*" className="hidden" onChange={upload} data-testid="media-upload-input" /></label>
      </div>

      {items.length === 0 ? <p className="font-body text-sm text-ink/50">No media yet. Upload your first asset.</p> : (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {items.map((it) => (
            <div key={it.id} className="adm-card p-2" data-testid={`media-item`}>
              <div className="aspect-square bg-cream overflow-hidden mb-2 flex items-center justify-center">
                {(it.content_type || "").startsWith("video") ? <video src={mediaUrl(it.url)} className="w-full h-full object-cover" muted /> : <img src={mediaUrl(it.url)} alt="" className="w-full h-full object-cover" />}
              </div>
              <p className="font-body text-[0.6rem] truncate">{it.original_filename}</p>
              <p className="font-body text-[0.55rem] text-ink/50">{it.width && it.height ? `${it.width}×${it.height}px` : "—"} · {(it.size / 1024).toFixed(0)}KB</p>
              <div className="flex justify-between mt-2">
                <button onClick={() => copy(it)} className="icon-thin text-ink/50 hover:text-ink"><Copy size={13} /></button>
                <button onClick={() => del(it)} className="icon-thin text-ink/50 hover:text-destructive"><Trash2 size={13} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
